module.exports = __webpack_public_path__ + "img/users-inactive.946d7b0e.svg";